import React, { useState, useEffect } from 'react';
import { auth, googleProvider } from '../firebase';
import { signInWithPopup, signOut } from 'firebase/auth';
import { Lock } from 'lucide-react';
import { getPreviewRole } from '../utils/previewRole';
import './PlayerGate.css';

const PlayerGate = ({ children, onPlayerLogin }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setUser(user);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const handleGoogleSignIn = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      if (onPlayerLogin) {
        onPlayerLogin(result.user);
      }
    } catch (error) {
      console.error('Player sign in error:', error);
    }
  };

  const handleSignOut = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Sign out error:', error);
    }
  };

  // Dev-only: ?previewRole= skips Google sign-in so the quiz UI can be previewed locally
  if (getPreviewRole()) {
    return children;
  }

  if (loading) {
    return (
      <div className="player-gate-container">
        <div className="player-gate-content">
          <div className="loading-spinner"></div>
          <p className="loading-text">Authenticating player...</p>
        </div>
      </div>
    );
  }

  // Not signed in
  if (!user) {
    return (
      <div className="player-gate-container">
        <div className="player-gate-content">
          <div className="player-gate-header">
            <h1>Quiz Access Required</h1>
            <p>Please sign in to access this quiz</p>
          </div>
          
          <div className="player-gate-actions">
            <button 
              className="player-signin-btn"
              onClick={handleGoogleSignIn}
            >
              <Lock className="google-icon" size={18} />
              Sign in with Google
            </button>
            
            <button 
              className="player-signout-btn"
              onClick={handleSignOut}
            >
              Back to Admin
            </button>
          </div>
          
          <div className="player-info">
            <p className="player-email-hint">Sign in as any Google account to play</p>
          </div>
        </div>
      </div>
    );
  }

  // Authorized player - render children
  return children;
};

export default PlayerGate;
